import type { RouteObject } from "react-router";
import { SampleRoute } from "@/routes/base-data/sample/sample-route";
import { sampleRoutes } from "@/routes/base-data/sample/sample-routes";
import { CustomersRoute } from "./customers/customers-route";
import { customersRoutes } from "./customers/customers-routes";
import { FeatureAuthRoute } from "./feature-auth/feature-auth-route";
import { CompaniesRoute } from "./companies/companies-route";

export const baseDataRoutes: RouteObject[] = [
  {
    path: "customers",
    element: <CustomersRoute />,
    children: customersRoutes,
  },
  {
    path: "",
    element: <SampleRoute />,
    children: sampleRoutes,
  },
  {
    path: "feature-auth",
    element: <FeatureAuthRoute />,
  },
  {
    path: "companies",
    element: <CompaniesRoute />,
  },
];
